import { Input, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { SelectChangeEvent } from "@mui/material/Select";
import React from "react";
import { Controller } from "react-hook-form";

import IconRightArrow from "../../../../assets/images/icons/icon_right_arrow.svg";
import HorizontalBox from "../../../../components/Boxes/HorizontalBox/HorizontalBox";
import Button from "../../../../components/Buttons/Button/Button";
import ImgIcon from "../../../../components/ImgIcon/ImgIcon";
import InformationPanel from "../../../../components/InformationPanel/InformationPanel";
import { CloseIcon } from "../../../../components/Modal/NextStepDialog/NextStepDialog.styles";
import SingleSelect from "../../../../components/SingleSelect/SingleSelect";
import useDocumentsContext from "../../hooks/useDocumentsContext.hooks";
import { ActionButtonBox, PanelActionBox, Title } from "./EditPanel.styles";
import useEditPanel from "./useEditPanel.hooks";

type File = { id: string; type: "folder" | "file" };

interface Props {
  title: string;
  open?: boolean;
  handleClose?: () => void;
  files: File[],
}

const EditPanel = ({
  title,
  open = false,
  handleClose = () => {},
  files = [],
}:Props) => {

  const { state, updateFiles } = useDocumentsContext();

  const {
    getFunds,
    getInvestors,
    getQuarters,
    handleSubmit,
    handleSave,
    onClose,
    loading,
    control,
  } = useEditPanel(state, { handleClose, files, updateFiles });
  

  return (
    <React.Fragment key="right">
      <InformationPanel
        id="edit_file_drawer"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: { width: { md: "50%" } }
        }}
      >
        <Box>
          <HorizontalBox>
            <Title id="title">
              {title} <ImgIcon icon={IconRightArrow} />
            </Title>
            <PanelActionBox>
              <CloseIcon
                id="btn_bulk_edit_file_close"

                onClick={onClose}
              />
            </PanelActionBox>
          </HorizontalBox>
          <Grid container sx={{ padding: theme => theme.spacing(2.5, 4.5) }} rowSpacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label="Name"
                value="Multiple Files Selected"
                disabled
                focused
                fullWidth
                inputProps={{
                  style: { padding: "9px 14px" }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="investor"
                render={({
                  field: {
                    onChange,
                    value
                  },
                  fieldState: {
                    error
                  }
                }) => {
                  return (<SingleSelect
                      id="select_investor"
                      disabled={loading}
                      optionList={getInvestors()}
                      label="Investor"
                      fullWidth={true}
                      idField="value"
                      labelField="label"
                      handleOptionSelection={(event: SelectChangeEvent) => onChange(event.target.value)}
                      value={value ?? ''}
                      error={!!error}
                      noGutter={true}
                      helperText={error?.message ?? ''}
                    />
                  );
                }}
                control={control}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="fund"
                render={({
                  field: {
                    onChange,
                    value
                  },
                  fieldState: {
                    error
                  }
                }) => {
                  return (<SingleSelect
                      id="select_fund"
                      disabled={loading}
                      optionList={getFunds()}
                      label="Fund"
                      fullWidth={true}
                      idField="value"
                      labelField="label"
                      handleOptionSelection={(event: SelectChangeEvent) => onChange(event.target.value)}
                      value={value ?? ''}
                      error={!!error}
                      noGutter={true}
                      helperText={error?.message ?? ''}
                    />
                  );
                }}
                control={control}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="quarter"
                render={({
                  field: {
                    onChange,
                    value
                  },
                  fieldState: {
                    error
                  }
                }) => {
                  return (<SingleSelect
                      id="select_quarter"
                      disabled={loading}
                      optionList={getQuarters()}
                      label="Quarter"
                      fullWidth={true}
                      idField="value"
                      labelField="label"
                      handleOptionSelection={(event: SelectChangeEvent) => onChange(event.target.value)}
                      value={value ?? ''}
                      error={!!error}
                      noGutter={true}
                      helperText={error?.message ?? ''}
                    />
                  );
                }}
                control={control}
              />
            </Grid>
          </Grid>
          <HorizontalBox
            addTopShadow
            attachToBottom={true}
            hidden={false}
            fullWidth
            stickToCenter
          >
            <ActionButtonBox>
              <Button
                id={"btn_edit_file_detail_panel_cancel"}
                variant="outlined"
                onClick={onClose}
                text="Cancel"
                color="error"
                fullWidth
                disabled={loading}
                addSpaceBetweenButtons
              />

              <Button
                id={"btn_edit_file_detail_panel_save"}
                variant="contained"
                onClick={() => handleSubmit(handleSave)}
                text="Save &amp; Close"
                color={"primary"}
                fullWidth
                disabled={loading}
                addSpaceBetweenButtons
              />
            </ActionButtonBox>
          </HorizontalBox>
        </Box>
      </InformationPanel>
    </React.Fragment>
  );
};

export default EditPanel;